import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { Comview } from './components/comview';

const ComisionesPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'comisiones',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Comisiones</PageTitle>
      <Comview/>
    </>
  );
};

export {ComisionesPage}